"use client";

import React, { useEffect, useState } from "react";
import type { Nullable } from "../../../@types/generic";
import { cn } from "../../../helpers/classNames";
import { useCountry } from "../../../hooks/useCountry";
import styles from "./styles.module.scss";
import type { MenuDesktopConfig } from "./types";

export const MenuDesktop: React.FC = () => {
    const country = useCountry();
    const [overlayIndexToShow, setOverlayIndexToShow] =
        useState<Nullable<number>>(null);
    const [menuConfig, setMenuConfig] = useState<MenuDesktopConfig>([]);

    useEffect(() => {
        if (menuConfig.length === 0) {
            const fetchMenuConfig = async (): Promise<void> => {
                const menuConfig = (await import(`./config.${country}`).then(
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
                    (mod) => mod.default
                )) as MenuDesktopConfig;
                setMenuConfig(menuConfig);
            };

            void fetchMenuConfig();
        }
    }, [country, menuConfig.length]);

    return (
        <nav aria-label="Hauptmenü" className={styles.nav}>
            {menuConfig.map((item, index) => (
                <div
                    key={`1.${index}`}
                    className={styles.mainItem}
                    role="menuitem"
                    tabIndex={0}
                    onMouseOver={() => setOverlayIndexToShow(index)}
                    onFocus={() => setOverlayIndexToShow(index)}
                    onMouseLeave={() => setOverlayIndexToShow(null)}
                    onBlur={() => setOverlayIndexToShow(null)}
                >
                    <a
                        href={item.href}
                        className={styles.mainItemLink}
                        aria-label={item.headline}
                    >
                        <span>{item.headline}</span>
                    </a>
                    {item.overlayContent.length > 0 && (
                        <div
                            className={cn(
                                styles.overlay,
                                overlayIndexToShow === index &&
                                    styles.overlayVisible
                            )}
                        >
                            {item.overlayContent.map((column, columnIndex) => (
                                <div
                                    key={`1.${index}${columnIndex}`}
                                    className={styles.column}
                                >
                                    {column.map((link, linkIndex) => {
                                        if (!link.href) {
                                            return (
                                                <span
                                                    key={`1.${index}${columnIndex}${linkIndex}`}
                                                    className={cn(
                                                        styles.link,
                                                        link.isMainItem
                                                            ? styles.mainLink
                                                            : styles.subLink
                                                    )}
                                                    role="menuitem"
                                                >
                                                    {link.label}
                                                    {link.withAdNotice && (
                                                        <span
                                                            className={
                                                                styles.adNotice
                                                            }
                                                        >
                                                            &nbsp;ANZEIGE
                                                        </span>
                                                    )}
                                                </span>
                                            );
                                        }

                                        return (
                                            <a
                                                key={`1.${index}${columnIndex}${linkIndex}`}
                                                className={cn(
                                                    styles.link,
                                                    styles.withHover,
                                                    link.isMainItem
                                                        ? styles.mainLink
                                                        : styles.subLink
                                                )}
                                                href={link.href}
                                                role="menuitem"
                                            >
                                                {link.label}
                                            </a>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </nav>
    );
};
